import Make from 'types/Make';
import Model from 'types/Model';
import { ListItem } from 'types/TextSearch';
// Turns the denormalized list object into something that
// is easier to understand for the search
export class Result {
  constructor(private listItem: ListItem) {
    this.listItem = listItem;
  }

  get trim(): string[] | undefined {
    return this.listItem.searchParams.trim ? [this.listItem.searchParams.trim] : undefined;
  }

  get make(): Make | undefined {
    if (!this.listItem.searchParams.make) return undefined;
    return {
      name: this.listItem.searchParams.make,
    };
  }

  get model(): Model | undefined {
    if (!this.listItem.searchParams.model) return undefined;
    return {
      name: this.listItem.searchParams.model,
    };
  }

  get bodyType(): string | undefined {
    const bodyType = this.listItem.searchParams.body_type;
    if (!bodyType) {
      return undefined;
    }

    return bodyType;
  }
}
